var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.value)?_c('v-icon',{attrs:{"small":"","color":"green"}},[_vm._v(" pic-check ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }